import { Avatar, Card, Divider, Row, Icon } from "antd";
import * as React from "react";

import { IBuxtonSupportTeamMember, IUser } from "../../../../Models/Models";
import { Loading } from "../../../Common/Loading/Loading";
import * as userActions from "../../../../Actions/UserActions";
import { BuxTooltip } from "../../../Common/BuxTooltip/BuxTooltip";
import { ScoutFeature } from "../../../../Enums/ScoutFeature";

const gridStyle: React.CSSProperties = {
    width: "30%",
    maxWidth: "200px",
    minWidth: "180px",
    border: "0px solid transparent",
    boxShadow: "none",
    margin: "4px",
};

interface IAccountTeamProps {
  user: IUser;
  companySupportTeam: Array<IBuxtonSupportTeamMember>;
  getCompanySupportTeam: () => void;
}

interface IAccountTeamState {}

class AccountTeam extends React.Component<
  IAccountTeamProps,
  IAccountTeamState
> {
  private intercomButton: JSX.Element = userActions.hasFeature(
      this.props.user,
      ScoutFeature.IntercomConversation
  ) ? (
          <div className="buxton-intercom">
              <img
                  style={{ marginLeft: "auto", marginRight: "auto", display: "none" }}
                  src="/Images/NEW_UI/left_nav/close-white.svg"
                  className="buxton-intercom-content-close"
              />
              <img
                  style={{ marginLeft: "auto", marginRight: "auto" }}
                  src="/Images/NEW_UI/left_nav/intercom-chat-with-buxton.svg"
                  className="buxton-intercom-content-open"
              />
          </div>
      ) : null;

  public componentWillMount() {
      if (this.props.companySupportTeam.length === 0) {
          console.info("They have no support! Getting their team");
          this.props.getCompanySupportTeam();
      }
  }

  public render() {
      if (this.props.companySupportTeam.length > 0) {
          const buxtonSupport: Array<IBuxtonSupportTeamMember>
        = this.props.companySupportTeam.filter(
            (member: IBuxtonSupportTeamMember) => member.isSupport
        );

          const accountOwner: IBuxtonSupportTeamMember
        = this.props.companySupportTeam.find(
            (member: IBuxtonSupportTeamMember) => member.isAccountOwner
        );
          const primaryContact: IBuxtonSupportTeamMember
        = this.props.companySupportTeam.find(
            (member: IBuxtonSupportTeamMember) => member.isPrimaryContact
        );

          const accountOwnerCard: JSX.Element = accountOwner ? (
              <Card.Grid style={gridStyle}>
                  {this.getSupportTeamMemberAvatar(accountOwner)}
                  <div className="account-card-content">
                      <div>
                          {accountOwner.firstName} {accountOwner.lastName}
                      </div>
                      <div>{accountOwner.title}</div>
                      {/* <a href={this.getSupportTeamMemberMailTo(accountOwner)}>{accountOwner.emailAddress}</a>
                        <div>(817) 332-3681</div> */}
                  </div>
              </Card.Grid>
          ) : null;
          const primaryContactCard: JSX.Element = primaryContact ? (
              <Card.Grid style={gridStyle}>
                  {this.getSupportTeamMemberAvatar(primaryContact)}
                  <div className="account-card-content">
                      <div>
                          {primaryContact.firstName} {primaryContact.lastName}
                      </div>
                      <div>{primaryContact.title}</div>
                      {/* <a href={this.getSupportTeamMemberMailTo(primaryContact)}>{primaryContact.emailAddress}</a>
                        <div>(817) 332-3681</div> */}
                  </div>
              </Card.Grid>
          ) : null;

          const buxtonSupportCards: Array<JSX.Element> = buxtonSupport
              ? buxtonSupport.map((member: IBuxtonSupportTeamMember): JSX.Element => {
                  return (
                      <Card.Grid style={gridStyle} key={member.supportID}>
                          {this.getSupportTeamMemberAvatar(member)}
                          <div className="account-card-content">
                              <div>
                                  {member.firstName} {member.lastName}
                              </div>
                              <div>{member.title}</div>
                              {/* <a href={this.getSupportTeamMemberMailTo(member)}>{member.emailAddress}</a>
                            <div>(817) 332-3681</div> */}
                          </div>
                      </Card.Grid>
                  );
              })
              : null;

          const accountManagerSection: JSX.Element
        = accountOwner || primaryContact ? (
            <React.Fragment>
                <div className="section-title">
              Management
                    <BuxTooltip
                        placement="right"
                        content={
                            <React.Fragment>
                                <p>
                      The Account Management Team is responsible for building
                      strong client partnerships and guiding clients through
                      every aspect of the Buxton engagement. This includes
                      delivery and implementation of client specific solutions,
                      strategic planning, and other related questions.
                                </p>
                            </React.Fragment>
                        }
                        trigger="click"
                        style={{ marginLeft: "1rem" }}
                    />
                </div>
                <Divider style={{ marginBottom: 0 }} />
                <Row>
                    <Card bordered={false}>
                        {accountOwnerCard}
                        {primaryContactCard}
                    </Card>
                </Row>
            </React.Fragment>
        ) : null;

          return (
              <div className="AccountTeam">
                  <h2 className="settings-title">Account Team</h2>
                  {accountManagerSection}
                  <div className="section-title">
            Support
                      <BuxTooltip
                          placement="right"
                          content={
                              <React.Fragment>
                                  <p>
                    The SCOUT Support Team is responsible for training clients
                    and ensuring they get the maximum value out of their
                    experience in SCOUT. This includes assisting with tactical
                    questions about day-to-day SCOUT usage and troubleshooting.
                                  </p>
                              </React.Fragment>
                          }
                          trigger="click"
                          style={{ marginLeft: "1rem" }}
                      />
                  </div>
                  <Divider style={{ marginBottom: 0 }} />
                  <Row>
                      <Card bordered={false}>{buxtonSupportCards}</Card>
                  </Row>
                  <Divider />
                  <Row>
                      <Card bordered={false}>
                          <div style={{ marginBottom: ".5rem" }}>
                              <Icon
                                  type="phone"
                                  style={{ fontSize: "20px", marginRight: "1rem" }}
                              />
                              <span style={{ color: "#979797" }}>(817) 332-3681</span>
                          </div>
                          <div style={{ color: "#979797", fontStyle: "italic" }}>
                Support Hours: Monday-Friday 8-5 CST
                          </div>
                      </Card>
                  </Row>
                  {this.intercomButton}
              </div>
          );
      } else {
          return (
              <div className="AccountTeam">
                  <Loading title="Loading Your Account Team" />
              </div>
          );
      }
  }

  private getSupportTeamMemberAvatar = (
      teamMember: IBuxtonSupportTeamMember
  ): JSX.Element => {
      if (teamMember.profileImage && teamMember.profileImage.trim().length > 0) {
          return <Avatar src={teamMember.profileImage} size={64} />;
      }

      return (
          <Avatar size={64} style={{ backgroundColor: "#125B4A" }}>
              {teamMember.firstName[0]} {teamMember.lastName[0]}
          </Avatar>
      );
  };

  private getSupportTeamMemberMailTo = (
      teamMember: IBuxtonSupportTeamMember
  ): string => {
      return `mailto:${teamMember.emailAddress}`;
  };
}

export default AccountTeam;
